export default __webpack_public_path__ + "static/media/calander.0290b056.svg";